import { User, UserHttp } from 'data/models/user.interface';
import day from 'plugins/dayjs';

export const toUser = (user: Partial<UserHttp>): User => {
  const firstName = user.attributes?.last_name || '';
  const lastName = user.attributes?.first_name || '';
  const fullName = user.attributes?.full_name || '';

  return {
    firstName,
    lastName,
    fullName,
    initials: `${firstName.charAt(0)}${lastName.charAt(0)}`,
    job: user.attributes?.job || '',
    permissions: user.attributes?.permissions || [],
    scopes: user.attributes?.scopes || [],
    email: user.attributes?.email || '',
    lastConnection: day(user.attributes?.last_connection || ''),
    isAuthenticated: (user.attributes?.id && true) || false,
  };
};
